import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import MainLayout from '../layouts/MainLayout';

function ProtectedRoute({ children, noLayout = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // You might want to show a loading spinner here
    return <div>Loading...</div>;
  }

  if (!user) {
    // Redirect to login but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Optionally bypass MainLayout (for pop-out windows, etc.)
  if (noLayout) return children;
  return <MainLayout>{children}</MainLayout>;
}

export default ProtectedRoute;
